const symptoms = [
  "Fenêtre qui ne ferme plus",
  "Oscillo-battant bloqué en position",
  "Poignée qui tourne dans le vide",
  "Crémone cassée",
  "Courant d'air / infiltration",
  "Fenêtre qui frotte",
];

export default function Symptoms() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Symptômes fréquents
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum">
            Vous reconnaissez l'un de ces problèmes ?
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {symptoms.map((s) => (
            <div
              key={s}
              className="flex items-center gap-4 bg-white border border-rose-200 rounded-2xl p-5 md:p-6 hover:bg-rose-50 transition-colors duration-300"
            >
              <div className="w-10 h-10 rounded-full bg-coral/10 flex items-center justify-center shrink-0">
                <i className="ri-check-line text-coral text-lg" />
              </div>
              <span className="text-plum-dark font-medium text-sm md:text-base">{s}</span>
            </div>
          ))}
        </div>
        <div className="mt-10 md:mt-14 text-center">
          <a
            href="tel:0374471036"
            className="inline-flex items-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
          >
            <i className="ri-phone-line" />
            Appeler maintenant — 03 74 47 10 36
          </a>
        </div>
      </div>
    </section>
  );
}